import userAPI from '../../API/user.service.api';
import UniqueList, {
  convertItemsToArray,
  convertItemsToSet,
} from './uniqueList';
import { SEARCH_BAR_HISTORY } from '../../constants/mainSearch.constants';

const userHistoryService = (category) => {
  if (!category) {
    throw new Error(
      'You should pass as an argument a category into userHistoryService function. There is categories object userHistory in /constants/user.constants file'
    );
  }

  let history = {};

  const set = (data) => {
    history = convertItemsToSet({ ...data });
  };

  const get = (scope) =>
    scope && history[scope].size
      ? Array.from(history[scope].values()).reverse()
      : convertItemsToArray({ ...history }, true);

  const update = (userId) => {
    if (userId) {
      userAPI.setHistorySelectedData(
        userId,
        category,
        convertItemsToArray({ ...history })
      );
    }
  };

  const add = (el, scope, userId) => {
    const list = new UniqueList();
    if (history[scope]) {
      history[scope].add(el);
    } else {
      history[scope] = list.add(el);
    }
    update(userId);
  };

  const upload = () => {
    userAPI
      .getHistorySearchData(category)
      .then((res) => {
        const { code, entities } = res;
        if (code === 200 && entities) {
          const data =
            typeof entities === 'string' ? JSON.parse(entities) : entities;
          if (data) {
            data[SEARCH_BAR_HISTORY] = [];
            set(data);
          }
        } else {
          console.log(res);
        }
      })
      .catch((err) => console.log(err));
  };

  upload();

  return {
    get,
    add,
  };
};

export default userHistoryService;
